import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-medium transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:     "border-transparent bg-primary text-primary-foreground",
        secondary:   "border-transparent bg-secondary text-secondary-foreground",
        outline:     "border-border bg-card text-foreground",
        muted:       "border-transparent bg-muted text-muted-foreground",
        accent:      "border-transparent bg-accent text-accent-foreground",
        warm:        "border-transparent bg-[hsl(var(--brand-warm)/0.14)] text-[hsl(var(--brand-warm))]",
        ochre:       "border-transparent bg-[hsl(var(--brand-ochre)/0.16)] text-[hsl(var(--brand-ochre))]",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        present:     "border-transparent bg-[hsl(var(--state-present-bg))] text-[hsl(var(--state-present))]",
        missing:     "border-transparent bg-[hsl(var(--state-missing-bg))] text-[hsl(var(--state-missing))]",
        unknown:     "border-transparent bg-[hsl(var(--state-unknown-bg))] text-[hsl(var(--state-unknown))]",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
